// extracted by mini-css-extract-plugin
export default {"root":"keg4a","title":"pFRW8","text":"UDhRx"};